import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const InsufficiantFundModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "#0D0D0D",
          border: "1px solid rgba(255, 255, 255, 0.20)",
          borderRadius: "16px",
          p: "32px",
          width: "500px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: "0px",
          pb: "12px",
          color: "#fff",
          fontWeight: "900",
          fontSize: "24px",
          borderBottom: "1px solid #ffffff33",
        }}
      >
        Insufficient fund
        <IconButton
          onClick={onClose}
          sx={{ float: "right", color: "#fff", p: "0px" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="start"
        mt={"26px"}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 500,
            textAlign: "start",
            color: "#fff",
          }}
        >
          Oops! You're out of funds to buy a player.
        </Typography>
      </Box>
    </Dialog>
  );
};

export default InsufficiantFundModal;
